<script>
  import options from './SchemaLeaf.options'
  export default options
</script>

<template>
  <SchemaMarkupCheckbox
    v-if="field.control === 'checkbox'"
    v-model="field.value"
    :label="field.label"
    :disabled="field.readonly"
  />
  <SchemaMarkupNumber
    v-else-if="field.control === 'number'"
    v-model="field.value"
    :label="field.label"
    :readonly="field.readonly"
  />
  <SchemaMarkupDate
    v-else-if="field.control === 'date'"
    v-model="field.value"
    :label="field.label"
    :format="field.format"
    :readonly="field.readonly"
  />
  <SchemaMarkupDropdown
    v-else-if="field.control === 'dropdown'"
    v-model="field.value"
    :label="field.label"
    :options="field.options"
    :disabled="field.readonly"
  />
  <div v-else-if="field.control === 'textarea'" class="kb-field kb-field--textarea">
    <label v-if="field.label" class="kb-field__label">{{ field.label }}</label>
    <textarea class="kb-field__input" v-model="field.value" :readonly="field.readonly"></textarea>
  </div>
  <SchemaMarkupTextField v-else v-model="field.value" :label="field.label" :readonly="field.readonly" />
</template>
